module.exports = __webpack_public_path__ + "media/images/general/school_quote-d7f558653596b02cda40a15a5ba463db.svg";